import _axios from "../axios.config";
import { END_POINTS } from "./endPoints";


export const postReview = async (ID, data, callback) => {
    try {
        let response = await _axios.post(`${END_POINTS.REVIEWS}/${ID}`, data);
        console.log(response);
        if (callback) callback(response?.data);
        return response?.data;
    } catch (e) {
        callback(e);
    }
};